import { memo } from "react";
import { DownDropContainer } from "@tecorien/mimic";
import { links } from "links";

import { ReactComponent as HelpIcon } from "./icons/questionHelp.svg";
import { ReactComponent as SupportIcon } from "./icons/support.svg";

import styles from "./styles.module.scss";

export const Help = memo(() => {
  return (
    <DownDropContainer
      trigger="click"
      dropdownClassName={styles.helpWrapper}
      component={
        <button type="button" className={styles.button}>
          <HelpIcon />
        </button>
      }
      item={{
        id: "help",
        label: "Help",
        items: [
          {
            id: "support",
            externalPath: links.support,
            label: "Support",
            icon: <SupportIcon />,
          },
        ],
      }}
    />
  );
});

export default Help;